import { LocationSelectorItem } from "types";

export const toKey = (
  value: string | null | undefined,
  empty: string,
) => value ?? empty;

export const ARTICLE_LOCATION_EMPTY_OPTIONS = {
  lote: "Sin Lote",
  oc: "Sin OC",
  apc: "Sin Cant. x Cont",
  fv: "Sin Fecha",
} as const;

export const ARTICLE_LOCATION_EMPTY_VALUE = "";

export const eqKey = (
  selected: string | undefined,
  current: string | null | undefined,
  empty: string,
) => toKey(current, empty) === (selected ?? empty);

export const uniqueValues = <T,>(values: T[]) => Array.from(new Set(values));

export const splitParentFromCode = (code: string) => {
  const separatorIndex = code.indexOf("-");

  if (separatorIndex === -1) {
    return { parent: code, sub: "" };
  }

  return {
    parent: code.slice(0, separatorIndex),
    sub: code,
  };
};

export const buildLocationsById = (
  locations: LocationSelectorItem[],
) => {
  const map = new Map<number, LocationSelectorItem>();

  locations.forEach((location) => {
    map.set(location.id, location);
  });

  return map;
};

export const buildParentAndSubLocation = (
  currentLocation: LocationSelectorItem,
  locationsById: Map<number, LocationSelectorItem>,
) => {
  if (!currentLocation.parent_location_id) {
    return { parent: currentLocation.code, sub: "" };
  }

  const parentLocation = locationsById.get(currentLocation.parent_location_id);

  if (parentLocation?.code) {
    return { parent: parentLocation.code, sub: currentLocation.code };
  }

  const fallback = splitParentFromCode(currentLocation.code);

  return { parent: fallback.parent, sub: currentLocation.code };
};

export const getArticleLocationAmountPerContainer = <
  T extends {
    article_locations?: {
      amount_per_container?: number | null;
    } | null;
  },
>(
  movementArticle?: T | null,
) => {
  const value = movementArticle?.article_locations?.amount_per_container;

  return value != null ? Number(value) : null;
};
